type SectionHeaderProps = {
    eyebrow: string
    title: string
    titleID?: string
    meta?: React.ReactNode
    action?: React.ReactNode
}

const SectionHeader = ({ eyebrow, title, titleID, meta, action }: SectionHeaderProps) => (
    <div className='mb-4 flex min-h-[58px] flex-col justify-between gap-3 sm:flex-row sm:items-end'>
        <div className='min-w-0'>
            <p className='text-xs font-semibold uppercase tracking-wider text-brand-600 dark:text-brand-400'>{eyebrow}</p>
            <h2 id={titleID} className='mt-1 text-xl font-semibold text-gray-900 dark:text-white'>
                {title}
            </h2>
            {meta && <div className='mt-2'>{meta}</div>}
        </div>
        {action && <div className='shrink-0'>{action}</div>}
    </div>
)

export default SectionHeader
